import classnames from 'classnames';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

type TextAreaProps = FieldRenderProps<string, HTMLElement, string> & {
  labelText?: string;
};

const TextArea: FC<TextAreaProps> = ({
  input,
  labelText,
  meta: { touched, error },
  ...otherProps
}) => {
  return (
    <>
      <label
        htmlFor={input.name}
        className={classnames('mb-1 block text-sm font-medium text-gray-700', {
          'sr-only': !labelText,
        })}
      >
        {labelText || input.name}
      </label>
      <textarea
        id={input.name}
        className={classnames(
          'block w-full rounded-md border-gray-300 text-sm shadow-sm',
          {
            'border-red-800': touched && error,
          },
        )}
        {...input}
        {...otherProps}
      />
      {touched && error && (
        <span className="text-xs text-red-800">{error}</span>
      )}
    </>
  );
};

export default TextArea;
